export default {
    repeats: state => state.repeats,
    upcomingRepeats: state => state.upcomingRepeats,
    activeRepeat: state => state.activeRepeat,
    manageRepeatDialog: state => state.manageRepeatDialog,
    deleteRepeatDialog: state => state.deleteRepeatDialog,
    upcomingRepeatsDialog: state => state.upcomingRepeatsDialog
}
